var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-navigation-drawer",
    {
      key: _vm.curKey,
      attrs: {
        width: "427",
        right: "",
        temporary: "",
        fixed: "",
        "overlay-opacity": 0.1,
      },
      on: { input: _vm.onChange },
      model: {
        value: _vm.drawer,
        callback: function ($$v) {
          _vm.drawer = $$v
        },
        expression: "drawer",
      },
    },
    [
      _c(
        "v-container",
        {
          staticClass:
            "d-flex flex-column justify-space-around pa-0 fill-height",
          attrs: { fluid: "" },
        },
        [
          _c(
            "v-toolbar",
            {
              staticClass: "pr-3",
              staticStyle: { width: "100%" },
              attrs: { flat: "", dense: "" },
            },
            [
              _c(
                "v-toolbar-title",
                { staticClass: "text-subtitle-2" },
                [
                  _c(
                    "v-list-item-title",
                    { staticClass: "table-subttile text--primary" },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.curData
                            ? _vm.$getCommonLangValue(
                                _vm.curData["preferred_name"]
                              )
                            : ""
                        )
                      ),
                    ]
                  ),
                  _c(
                    "v-list-item-subtitle",
                    { staticClass: "table-subttile text--secondary" },
                    [
                      _vm._v(
                        _vm._s(_vm.curData ? _vm.curData["roster_date"] : "")
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c("v-spacer"),
              _c(
                "v-tooltip",
                {
                  attrs: { left: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function (ref) {
                        var on = ref.on
                        return [
                          _c(
                            "v-btn",
                            _vm._g(
                              {
                                attrs: {
                                  icon: "",
                                  color: "primary",
                                  small: "",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.closeDialog.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              on
                            ),
                            [
                              _c(
                                "span",
                                { staticClass: "material-icons-round" },
                                [_vm._v("close")]
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "label_essweb_RosterRecord_slide_adhoc_closeBtnTip"
                        )
                      )
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "v-container",
            {
              staticClass: "pa-0 scroll_content_y",
              style: { height: "calc(100% - 108px)" },
              attrs: { fluid: "" },
            },
            [
              _c("Taber", {
                attrs: {
                  curTab: _vm.curTab,
                  items: _vm.taber,
                  border: "",
                  height: 40,
                  special: "",
                  contentBackground: "fill-height",
                  backgroundColor: "white",
                },
                on: {
                  change: function (tab) {
                    return (_vm.curTab = tab)
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "content-1",
                    fn: function () {
                      return [
                        _vm.shiftList.length > 0 || _vm.search != ""
                          ? _c(
                              "v-form",
                              {
                                ref: "form3",
                                staticClass: "px-4 pa-0 py-2",
                                attrs: { "lazy-validation": "" },
                              },
                              [
                                _c(
                                  "v-row",
                                  { attrs: { dense: "" } },
                                  [
                                    _c(
                                      "v-col",
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            filled: "",
                                            clearable: "",
                                            dense: "",
                                            color: "grey",
                                            "prepend-inner-icon": "search",
                                            "clear-icon": "cancel",
                                            "single-line": "",
                                            "hide-details": "",
                                            placeholder:
                                              _vm.$t(
                                                "label_essweb_shift_list_shiftNameLabel"
                                              ) +
                                              "/" +
                                              _vm.$t(
                                                "label_essweb_shift_list_shiftAbbrLabel"
                                              ),
                                            rounded: "",
                                          },
                                          model: {
                                            value: _vm.search,
                                            callback: function ($$v) {
                                              _vm.search = $$v
                                            },
                                            expression: "search",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.shiftList.length > 0 || _vm.search != ""
                          ? _c("v-divider")
                          : _vm._e(),
                        _vm.shiftList.length == 0 ? _c("noContent") : _vm._e(),
                        _c(
                          "v-list",
                          {
                            staticClass:
                              "px-4 py-0 scroll_content_y scroll_content_x_no",
                            attrs: {
                              dense: "",
                              nav: "",
                              height: _vm.$vuetify.breakpoint.height - 232,
                            },
                            model: {
                              value: _vm.curSelect,
                              callback: function ($$v) {
                                _vm.curSelect = $$v
                              },
                              expression: "curSelect",
                            },
                          },
                          _vm._l(_vm.shiftList, function (it, i) {
                            return _c(
                              "v-list-item",
                              {
                                key: i,
                                staticClass:
                                  "d-flex text-left pl-0 my-4 pr-1 flex-3 flex-row",
                                style: {
                                  backgroundColor: it.color_code,
                                  height: "48px",
                                },
                                attrs: { color: it.color_code },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    _vm.curSelect = it.uuid
                                    _vm.editingShift = it
                                  },
                                },
                              },
                              [
                                _vm.curSelect == it.uuid
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "material-icons-round primary--text mr-n2 ml-2",
                                      },
                                      [_vm._v("check_circle")]
                                    )
                                  : _vm._e(),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "pl-3 text--primary text-subtitle-2 text-ellipsis-2",
                                    staticStyle: { "max-width": "70%" },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$getCommonLangValue(it.shift_abbr)
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "ml-auto text--secondary caption",
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.getStartEnd(it)) + " "
                                    ),
                                  ]
                                ),
                                it.is_allow_override_to_adhoc
                                  ? _c(
                                      "v-btn",
                                      {
                                        staticClass: "ml-3",
                                        attrs: {
                                          icon: "",
                                          small: "",
                                          disabled: _vm.curSelect != it.uuid,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toChangeShift(it)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "material-icons-round",
                                          },
                                          [_vm._v("edit")]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          }),
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "content-2",
                    fn: function () {
                      return [
                        _c(
                          "v-form",
                          { ref: "form", staticClass: "px-2" },
                          [
                            _c(
                              "v-row",
                              { attrs: { dense: "" } },
                              [
                                Number(_vm.is_allow_leave_remark)
                                  ? _c(
                                      "v-col",
                                      {
                                        attrs: {
                                          xs: "12",
                                          sm: "12",
                                          md: "12",
                                          lg: "12",
                                          cols: "12",
                                        },
                                      },
                                      [
                                        _c("AutoComplete", {
                                          attrs: {
                                            "single-line": "",
                                            label:
                                              "label_essweb_RosterRecord_slide_form_leaveRemarkLabel",
                                            "small-chips": "",
                                            "deletable-chips": "",
                                            chips: "",
                                            items: _vm.LeaveType,
                                            "item-text": "leave_type_name",
                                            "item-value": "uuid",
                                          },
                                          model: {
                                            value: _vm.leave_type_remark_uuid,
                                            callback: function ($$v) {
                                              _vm.leave_type_remark_uuid = $$v
                                            },
                                            expression:
                                              "leave_type_remark_uuid",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                Number(_vm.is_allow_site)
                                  ? _c(
                                      "v-col",
                                      {
                                        attrs: {
                                          xs: "12",
                                          sm: "12",
                                          md: "12",
                                          lg: "12",
                                          cols: "12",
                                        },
                                      },
                                      [
                                        _c("AutoComplete", {
                                          attrs: {
                                            "small-chips": "",
                                            chips: "",
                                            label:
                                              "label_essweb_shift_form_siteNameLabel",
                                            "deletable-chips": "",
                                            "two-line": "",
                                            items: _vm.siteList,
                                            "item-text": "view_fields",
                                            "item-value": "value_field",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "subtitle",
                                                fn: function (ref) {
                                                  var data = ref.data
                                                  return [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$getCommonLangValue(
                                                            data.item.f1
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            2839100397
                                          ),
                                          model: {
                                            value: _vm.site_uuid,
                                            callback: function ($$v) {
                                              _vm.site_uuid = $$v
                                            },
                                            expression: "site_uuid",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                Number(_vm.is_allow_cost_center)
                                  ? _c(
                                      "v-col",
                                      {
                                        attrs: {
                                          xs: "12",
                                          sm: "12",
                                          md: "12",
                                          lg: "12",
                                          cols: "12",
                                        },
                                      },
                                      [
                                        _c("AutoComplete", {
                                          attrs: {
                                            "small-chips": "",
                                            label:
                                              "label_essweb_ClaimRecord_form_dialog_costCentreLabel",
                                            chips: "",
                                            "deletable-chips": "",
                                            items: _vm.costCenter,
                                            "item-text": "view_fields",
                                            "item-value": "value_field",
                                          },
                                          model: {
                                            value: _vm.cost_center_uuid,
                                            callback: function ($$v) {
                                              _vm.cost_center_uuid = $$v
                                            },
                                            expression: "cost_center_uuid",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                Number(_vm.is_allow_temp_supervisor)
                                  ? _c(
                                      "v-col",
                                      {
                                        attrs: {
                                          xs: "12",
                                          sm: "12",
                                          md: "12",
                                          lg: "12",
                                          cols: "12",
                                        },
                                      },
                                      [
                                        _c("AutoComplete", {
                                          attrs: {
                                            items: _vm.allStaff,
                                            label:
                                              "label_essweb_RosterRecord_dialog_interimSupervisorLabel",
                                            chips: "",
                                            filter: _vm.$staffFilter,
                                            multiple: "",
                                            simple: "",
                                            avatar: "",
                                            "two-line": "",
                                            "item-text": "staff_code",
                                            "item-value": "staff_id",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "selection.avatar",
                                                fn: function (ref) {
                                                  var data = ref.data
                                                  return [
                                                    _c("StaffAvatar", {
                                                      attrs: {
                                                        left: "",
                                                        isTemp:
                                                          data.item.is_temp,
                                                        src: data.item
                                                          .staff_avatar,
                                                        staff_name:
                                                          data.item
                                                            .preferred_name,
                                                      },
                                                    }),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "selection",
                                                fn: function (ref) {
                                                  var data = ref.data
                                                  return [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$getCommonLangValue(
                                                            data.item
                                                              .preferred_name
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "item.avatar",
                                                fn: function (ref) {
                                                  var data = ref.data
                                                  return [
                                                    _c("StaffAvatar", {
                                                      attrs: {
                                                        size: "36",
                                                        isTemp:
                                                          data.item.is_temp,
                                                        src: data.item
                                                          .staff_avatar,
                                                        staff_name:
                                                          data.item
                                                            .preferred_name,
                                                      },
                                                    }),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "item.title",
                                                fn: function (ref) {
                                                  var data = ref.data
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-body-2",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$getCommonLangValue(
                                                              data.item
                                                                .preferred_name
                                                            )
                                                          ) + " "
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "text--secondary text-caption-xs",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                data.item
                                                                  .staff_code
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "item.subtitle",
                                                fn: function (ref) {
                                                  var data = ref.data
                                                  return [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$getCommonLangValue(
                                                            data.item
                                                              .job_post_name
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            742038239
                                          ),
                                          model: {
                                            value: _vm.selectStaff,
                                            callback: function ($$v) {
                                              _vm.selectStaff = $$v
                                            },
                                            expression: "selectStaff",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                Number(_vm.manual_is_allow_select_holiday)
                                  ? _c(
                                      "v-col",
                                      {
                                        attrs: {
                                          xs: "12",
                                          sm: "12",
                                          md: "12",
                                          lg: "12",
                                          cols: "12",
                                        },
                                      },
                                      [
                                        _c("AutoComplete", {
                                          attrs: {
                                            label:
                                              "label_ess_web_shift_dialog_slide_publicHolidayLabel",
                                            "small-chips": "",
                                            chips: "",
                                            "two-line": "",
                                            "deletable-chips": "",
                                            items: _vm.HolidayOff,
                                            "item-text": "holiday_name",
                                            "item-value": "uuid",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "selection",
                                                fn: function (ref) {
                                                  var data = ref.data
                                                  return [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$getCommonLangValue(
                                                            data.item
                                                              .holiday_name
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "item.title",
                                                fn: function (ref) {
                                                  var data = ref.data
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-body-2 d-flex align-center",
                                                      },
                                                      [
                                                        Number(data.item.is_old)
                                                          ? _c(
                                                              "i",
                                                              {
                                                                staticClass:
                                                                  "material-icons-round red--text mr-1",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "error_outline"
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$getCommonLangValue(
                                                                data.item
                                                                  .holiday_name
                                                              )
                                                            )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "item.subtitle",
                                                fn: function (ref) {
                                                  var data = ref.data
                                                  return [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$getCommonLangValue(
                                                            data.item
                                                              .holiday_abbr
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            4084756361
                                          ),
                                          model: {
                                            value: _vm.curHoliday,
                                            callback: function ($$v) {
                                              _vm.curHoliday = $$v
                                            },
                                            expression: "curHoliday",
                                          },
                                        }),
                                        _vm.HolidayOff.length > 0 && false
                                          ? _c(
                                              "v-menu",
                                              {
                                                attrs: { top: "" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function (ref) {
                                                        var on = ref.on
                                                        var attrs = ref.attrs
                                                        return [
                                                          _c(
                                                            "v-list-item",
                                                            {
                                                              staticClass:
                                                                "\n                        d-flex\n                        text-left\n                        pl-0\n                        my-2\n                        pr-1\n                        flex-3 flex-row\n                        rounded\n                      ",
                                                              style: {
                                                                height: "48px",
                                                                background:
                                                                  _vm.curHoliday ===
                                                                  null
                                                                    ? "#dadada"
                                                                    : "#eeeef0",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    _vm.showHoliday = true
                                                                    _vm.curHoliday =
                                                                      -1
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c("div", {
                                                                staticClass:
                                                                  "rounded mr-1",
                                                                style: {
                                                                  background:
                                                                    "grey",
                                                                  width: "5px",
                                                                  height:
                                                                    "48px",
                                                                },
                                                              }),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "text--primary text-body-2 text-ellipsis-2",
                                                                  staticStyle: {
                                                                    "max-width":
                                                                      "70%",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.$getCommonLangValue(
                                                                          _vm.holiday_name
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                              _c("v-spacer"),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "material-icons-round",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.showHoliday
                                                                        ? "arrow_drop_up"
                                                                        : "arrow_drop_down"
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  false,
                                                  1474466696
                                                ),
                                                model: {
                                                  value: _vm.showHoliday,
                                                  callback: function ($$v) {
                                                    _vm.showHoliday = $$v
                                                  },
                                                  expression: "showHoliday",
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-list",
                                                  { attrs: { dense: "" } },
                                                  _vm._l(
                                                    _vm.HolidayOff,
                                                    function (item, index) {
                                                      return _c(
                                                        "v-list-item",
                                                        {
                                                          key: index,
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              _vm.curHoliday =
                                                                item.uuid
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.$getCommonLangValue(
                                                                      item.holiday_name
                                                                    )
                                                                  )
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                Number(_vm.is_allow_remark)
                                  ? _c(
                                      "v-col",
                                      {
                                        attrs: {
                                          xs: "12",
                                          sm: "12",
                                          md: "12",
                                          lg: "12",
                                          cols: "12",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          { staticClass: "text--secondary" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "label_essweb_RosterRecord_slide_remarkLabel"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c("v-textarea", {
                                          attrs: {
                                            rows: "5",
                                            "no-resize": "",
                                            maxlength: "500",
                                            filled: "",
                                            "single-line": "",
                                            dense: "",
                                            counter: "500",
                                            name: "input-7-4",
                                          },
                                          model: {
                                            value: _vm.remarks,
                                            callback: function ($$v) {
                                              _vm.remarks = $$v
                                            },
                                            expression: "remarks",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
          _c("v-spacer"),
          _c(
            "v-sheet",
            {
              staticClass:
                "\n        align-center\n        text-center\n        flex-row\n        d-flex\n        justify-center\n        max-width\n      ",
              staticStyle: {
                "border-top": "1px solid var(--main-border-color)",
              },
              attrs: { height: "60" },
            },
            [
              _c(
                "v-btn",
                {
                  staticClass: "pl-7 pr-7 text-capitalize mr-2 text-body-1",
                  attrs: { color: "gery", rounded: "", text: "", height: "32" },
                  on: { click: _vm.closeDialog },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t("label_essweb_RosterRecord_slide_form_cancelLabel")
                    )
                  ),
                ]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "pl-7 pr-7 text-capitalize text-body-1",
                  attrs: {
                    color: "primary",
                    rounded: "",
                    height: "32",
                    loading: _vm.loading,
                    disabled: !_vm.curSelect || _vm.loading || _vm.isLoading,
                  },
                  on: { click: _vm.toSubmit },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "label_essweb_RosterRecord_slide_form_submitBtnLabel"
                      )
                    )
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      [
        _c(
          "v-navigation-drawer",
          {
            attrs: {
              width: "427",
              right: "",
              temporary: "",
              fixed: "",
              "overlay-opacity": 0.1,
            },
            model: {
              value: _vm.showEditShift,
              callback: function ($$v) {
                _vm.showEditShift = $$v
              },
              expression: "showEditShift",
            },
          },
          [
            _c(
              "v-container",
              {
                staticClass:
                  "d-flex flex-column justify-space-around pa-0 fill-height",
                attrs: { fluid: "" },
              },
              [
                _c(
                  "v-toolbar",
                  {
                    staticClass: "pr-3",
                    staticStyle: { width: "100%" },
                    attrs: { flat: "", dense: "" },
                  },
                  [
                    _c(
                      "v-toolbar-title",
                      { staticClass: "text-subtitle-2" },
                      [
                        _c(
                          "v-list-item-title",
                          { staticClass: "table-subttile text--primary" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "label_essweb_RosterRecord_slide_adhoc_title"
                                )
                              )
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c("v-spacer"),
                    _c(
                      "v-tooltip",
                      {
                        attrs: { left: "" },
                        scopedSlots: _vm._u([
                          {
                            key: "activator",
                            fn: function (ref) {
                              var on = ref.on
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    {
                                      attrs: {
                                        icon: "",
                                        color: "primary",
                                        small: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          _vm.showEditShift = false
                                        },
                                      },
                                    },
                                    on
                                  ),
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "material-icons-round" },
                                      [_vm._v("close")]
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "label_essweb_RosterRecord_slide_adhoc_closeBtnTip"
                              )
                            )
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _c("v-divider", { staticClass: "max-width" }),
                _c(
                  "v-container",
                  {
                    staticClass: "pa-4 scroll_content_y",
                    style: { height: "calc(100% - 109px)" },
                    attrs: { fluid: "" },
                  },
                  [
                    _c(
                      "v-form",
                      { ref: "form2", attrs: { "lazy-validation": "" } },
                      [
                        _c(
                          "v-row",
                          { attrs: { "no-gutters": "" } },
                          [
                            _c(
                              "v-col",
                              {
                                attrs: {
                                  xs: "12",
                                  sm: "12",
                                  md: "12",
                                  lg: "12",
                                  cols: "12",
                                },
                              },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    "single-line": "",
                                    filled: "",
                                    disabled: true,
                                    placeholder: "shift",
                                    dense: "",
                                  },
                                  model: {
                                    value: _vm.shiftData.shift_abbr,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.shiftData, "shift_abbr", $$v)
                                    },
                                    expression: "shiftData.shift_abbr",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                attrs: {
                                  xs: "12",
                                  sm: "12",
                                  md: "12",
                                  lg: "12",
                                  cols: "12",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "label_essweb_RosterRecord_slide_adhoc_abbrLabel"
                                    )
                                  )
                                ),
                              ]
                            ),
                            _c(
                              "v-col",
                              { attrs: { md: "3" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    "single-line": "",
                                    filled: "",
                                    placeholder: _vm.$t(
                                      "label_essweb_RosterRecord_slide_adhoc_prefixLabel"
                                    ),
                                    dense: "",
                                  },
                                  model: {
                                    value: _vm.shiftData.prefix_shift_abbr,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.shiftData,
                                        "prefix_shift_abbr",
                                        $$v
                                      )
                                    },
                                    expression: "shiftData.prefix_shift_abbr",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass:
                                  "d-flex justify-center align-top pt-3",
                                attrs: { md: "1" },
                              },
                              [_vm._v("-")]
                            ),
                            _c(
                              "v-col",
                              { attrs: { md: "3" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    "single-line": "",
                                    filled: "",
                                    disabled: true,
                                    placeholder: _vm.$t(
                                      "label_essweb_RosterRecord_slide_adhoc_abbrLabel"
                                    ),
                                    dense: "",
                                  },
                                  model: {
                                    value: _vm.shiftData.shift_abbr,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.shiftData, "shift_abbr", $$v)
                                    },
                                    expression: "shiftData.shift_abbr",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass:
                                  "d-flex justify-center align-top pt-3",
                                attrs: { md: "1" },
                              },
                              [_vm._v("-")]
                            ),
                            _c(
                              "v-col",
                              { attrs: { md: "3" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    "single-line": "",
                                    filled: "",
                                    placeholder: _vm.$t(
                                      "label_essweb_RosterRecord_slide_adhoc_suffixLabel"
                                    ),
                                    dense: "",
                                  },
                                  model: {
                                    value: _vm.shiftData.suffix_shift_abbr,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.shiftData,
                                        "suffix_shift_abbr",
                                        $$v
                                      )
                                    },
                                    expression: "shiftData.suffix_shift_abbr",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                attrs: {
                                  xs: "12",
                                  sm: "12",
                                  md: "12",
                                  lg: "12",
                                  cols: "12",
                                },
                              },
                              _vm._l(
                                _vm.shiftData.event_list,
                                function (item, index) {
                                  return _c(
                                    "v-container",
                                    {
                                      key: "event_list" + index,
                                      staticClass: "mt-4 pa-4",
                                      staticStyle: {
                                        border:
                                          "1px solid var(--main-border-color)",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "text-subtitle-2" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$getCommonLangValue(
                                                  item.event_business_name
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              attrs: {
                                                xs: "12",
                                                sm: "12",
                                                md: "12",
                                                lg: "12",
                                                cols: "12",
                                              },
                                            },
                                            [
                                              _c("TimePicker", {
                                                attrs: {
                                                  isRequire: "",
                                                  value: item.start_utc_time,
                                                  defaultTime:
                                                    item.start_utc_time,
                                                  max: item.end_utc_time,
                                                  label: _vm.$t(
                                                    "label_essweb_RosterRecord_slide_adhoc_startTimeLabel"
                                                  ),
                                                },
                                                on: {
                                                  change: function (time) {
                                                    item.start_utc_time = time
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              attrs: {
                                                xs: "12",
                                                sm: "12",
                                                md: "12",
                                                lg: "12",
                                                cols: "12",
                                              },
                                            },
                                            [
                                              _c("TimePicker", {
                                                attrs: {
                                                  isRequire: "",
                                                  isEnd: "",
                                                  showDay: "",
                                                  min: item.start_utc_time,
                                                  value: item.end_utc_time,
                                                  defaultTime:
                                                    item.end_utc_time,
                                                  label: _vm.$t(
                                                    "label_essweb_RosterRecord_slide_adhoc_endTimeLabel"
                                                  ),
                                                },
                                                on: {
                                                  change: function (time) {
                                                    item.end_utc_time = time
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("v-spacer"),
                _c(
                  "v-sheet",
                  {
                    staticClass:
                      "\n            align-center\n            text-center\n            flex-row\n            d-flex\n            justify-center\n            max-width\n          ",
                    staticStyle: {
                      "border-top": "1px solid var(--main-border-color)",
                    },
                    attrs: { height: "60" },
                  },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "pl-7 pr-7 text-capitalize mr-2",
                        attrs: {
                          color: "gery",
                          rounded: "",
                          text: "",
                          height: "32",
                        },
                        on: {
                          click: function ($event) {
                            _vm.showEditShift = false
                          },
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "label_essweb_RosterRecord_slide_adhoc_cancelLabel"
                            )
                          )
                        ),
                      ]
                    ),
                    _c(
                      "v-btn",
                      {
                        staticClass: "pl-7 pr-7 text-capitalize",
                        attrs: { color: "primary", rounded: "", height: "32" },
                        on: { click: _vm.toShift },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "label_essweb_RosterRecord_slide_adhoc_submitBtnLabel"
                            )
                          )
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }